import Cookie from 'js-cookie';
import { req } from 'react-reqq-lite';

import { formatGetQueryParams, transformIncluded } from 'modules/common/utils';
import { withAclReq } from 'modules/partial/hooks';

import * as t from './transformers';
import * as c from './constants';

export const getProducts = (
  { params, merchant_uuid, branch_uuid, qrKey } = {},
  cb
) => {
  if (qrKey) {
    req.get({
      key: c.GET_PRODUCTS,
      url: `/v1/customer/pos/${qrKey}/inventory/products`,
      params: formatGetQueryParams(params, true),
      transform: ({ data, meta, included }) => ({
        data: data?.map((item) => t.transformGetProducts(item, included)),
        meta: meta?.pagination,
      }),
      onSuccess: (res) => {
        if (typeof cb === 'function') cb(res);
      },
    });
    return;
  }

  req.get(
    withAclReq(
      () => ({
        ADMIN: {
          url: `/v1/vendors/${merchant_uuid}/branches/${branch_uuid}/inventory/products`,
        },
        MERCHANT: {
          url: `/v1/me/inventory/products`,
        },
        BRANCH: {
          url: `/v1/me/inventory/products`,
        },
      }),
      {
        key: c.GET_PRODUCTS,
        params: formatGetQueryParams(params, true),
        transform: ({ data, meta, included }) => ({
          data: data?.map((item) => t.transformGetProducts(item, included)),
          pagination: meta?.pagination,
        }),
        onSuccess: (res) => {
          if (typeof cb === 'function') cb(res);
        },
      }
    )
  );
};

export const getSelectedProducts = ({ signal, params } = {}, cb) => {
  req.set(`LOADING/get/${c.GET_SELECTED_PRODUCT}`, true);

  const $url = `${
    process.env.REACT_APP_END_POINT
  }/v1/me/inventory/products?${new URLSearchParams(
    formatGetQueryParams(params, true)
  )?.toString()}`;
  const token = Cookie.get('_token');

  fetch($url, {
    method: 'GET',
    headers: new Headers({
      Authorization: `Bearer ${token}`,
    }),
    signal,
  })
    .then((res) => res.json())
    .then((res) => {
      const v = res?.data?.map((item) =>
        t.transformGetProducts(item, res?.included)
      )?.[0];
      req.set(`LOADING/get/${c.GET_SELECTED_PRODUCT}`, false);
      req.set(c.GET_SELECTED_PRODUCT, v);
      if (cb) cb?.(v);
    })
    .catch((err) => {
      req.set(`LOADING/get/${c.GET_SELECTED_PRODUCT}`, false);
      console.log(err); // eslint-disable-line
    });
};

export const getSelectedProductsBck = (
  { params, merchant_uuid, branch_uuid } = {},
  cb
) => {
  req.get(
    withAclReq(
      () => ({
        ADMIN: {
          url: `/v1/vendors/${merchant_uuid}/branches/${branch_uuid}/inventory/products`,
        },
        MERCHANT: {
          url: `/v1/me/inventory/products`,
        },
        BRANCH: {
          url: `/v1/me/inventory/products`,
        },
      }),
      {
        key: c.GET_SELECTED_PRODUCT,
        params: formatGetQueryParams(params, true),
        transform: t.transformGetProducts,
        onSuccess: (res) => {
          if (typeof cb === 'function') cb(res);
        },
      }
    )
  );
};

export const getCategories = (
  { params, merchant_uuid, branch_uuid, qrKey } = {},
  cb
) => {
  if (qrKey) {
    req.get({
      key: c.GET_CATEGORIES,
      url: `/v1/customer/pos/${qrKey}/vendor-categories`,
      params: formatGetQueryParams(params, true),
      transform: ({ data, meta }) => ({
        data: data?.map(t.transformGetCategories),
        pagination: meta?.pagination,
      }),
      onSuccess: (res) => {
        if (typeof cb === 'function') cb(res);
      },
    });

    return;
  }

  req.get(
    withAclReq(
      () => ({
        ADMIN: {
          url: `/v1/vendors/${merchant_uuid}/branches/${branch_uuid}/vendor-categories`,
        },
        MERCHANT: {
          url: '/v1/me/vendor-categories',
        },
        BRANCH: {
          url: '/v1/me/vendor-categories',
        },
      }),
      {
        key: c.GET_CATEGORIES,
        params: formatGetQueryParams(params, true),
        transform: ({ data, meta }) => ({
          data: data?.map(t.transformGetCategories),
          pagination: meta?.pagination,
        }),
        onSuccess: (res) => {
          if (typeof cb === 'function') cb(res);
        },
      }
    )
  );
};

export const generateDraft = ({ qrKey } = {}) => {
  req.post({
    url: `/v1/customer/pos/${qrKey}`,
    key: c.GENERATE_DRAFT,
    onSuccess: (res) => {
      const { data, included } = res?.response || {};

      req.set(c.GENERATE_DRAFT, {
        data: transformIncluded(data, included),
      });
    },
  });
};
